import { createContext } from 'react';

export type SuspenseContextType =
  | {
      hasSuspenseWrapper: boolean;
    }
  | undefined;

export const SuspenseContext = createContext<SuspenseContextType>(undefined);
